import React, { Component } from 'react';
import ButtonIcon from '../../../../../button';
import { InvoiceRematch } from '../../../../../internal/Invoice/modal/invoice-rematch.component';
import { ListTabButton } from '../../../../list-tab/list-tab-button.component';
export default class ManageInvoiceLayout extends Component {

    constructor(props) {
        super(props);
        this.state={
            selectedIndex:0,
        }
    }


    FilterIndex(tabIndex){    
        this.setState({selectedIndex:tabIndex});  
        this.props.onGetSelected(tabIndex) 
    }

    CloseForm() {
        this.props.closeForm(false)
      
    }

    render(){
        return(
            <div className="remove-background request-table data-table request-table-invoice fit-width">
                 <ButtonIcon onClick={this.CloseForm.bind(this)} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back"/> 
                 <div className="request-table data-table ">
                       {this.props.haveHeaderButton && 
                        <div className="button-right-container">
                            <ButtonIcon onClick={()=>alert("click")} customClassName="header-filter-button" labelName="MJE"/> 
                            <ButtonIcon onClick={()=>alert("click")} iconLeft="cloud-arrow-down" iconSize="17px" customClassName="header-filter-button" labelName="E-Bill Extract"/> 
                            <InvoiceRematch />
                            <ButtonIcon onClick={()=>alert("click")}  customClassName="header-filter-button" labelName="Cost Allocation"/> 
                        </div>
                       }
                       
                        <div>
                            <ListTabButton listData={this.props.listData} selectedIndex={this.state.selectedIndex} FilterIndex={this.FilterIndex.bind(this)}/>
                        </div>

                        {this.props.children}
                 </div>
            </div>
        );
    }
}